enum BrokerDocumentTypeEnum {
    AfcaMembership = 'AFCA_MEMBERSHIP',
    AsicSearch = 'ASIC_SEARCH',
    CompanySearch = 'COMPANY_SEARCH',
    InsuranceProof = 'INSURANCE_PROOF',
    MembershipDocument = 'MEMBERSHIP_DOCUMENT',
    PhotoId = 'PHOTO_ID',
}

export default BrokerDocumentTypeEnum;
